export const minimumProgressDurationInMs = 1500
